import type { Translations } from '../types';

export const ru: Translations = {
  // Navigation
  nav: {
    home: 'Главная',
    meditations: 'Медитации',
    journal: 'Дневник',
    tasks: 'Задания',
    balance: 'Баланс',
    profile: 'Профиль',
  },

  // Common
  common: {
    loading: 'Загрузка...',
    save: 'Сохранить',
    saving: 'Сохранение...',
    cancel: 'Отмена',
    back: 'Назад',
    continue: 'Продолжить',
    skip: 'Пропустить',
    search: 'Поиск',
    all: 'Все',
    today: 'Сегодня',
    yesterday: 'Вчера',
    daysAgo: 'дн. назад',
    weeksAgo: 'нед. назад',
    minutes: 'мин',
    days: 'дней',
    friend: 'друг',
  },

  // Home page
  home: {
    goodMorning: 'Доброе утро',
    goodAfternoon: 'Добрый день',
    goodEvening: 'Добрый вечер',
    howAreYou: 'Как дела сегодня?',
    trackMood: 'Отслеживай своё эмоциональное состояние и прогресс',
    shareMood: 'Поделиться настроением',
    loadingMeditations: 'Загрузка медитаций...',
    popularToday: 'Популярное сегодня',
    popularNow: 'Популярное сейчас',
    forSleep: 'Для сна',
    practiceCalendar: 'Календарь практики',
    dailyWisdom: 'Мудрость дня',
    wisdomQuote: '"Счастье не в том, чтобы делать всегда то, что хочешь, а в том, чтобы всегда хотеть того, что делаешь."',
  },

  // Profile page
  profile: {
    memberSince: 'С нами с',
    consecutive: 'Подряд',
    balance: 'Баланс',
    myFriends: 'Мои друзья',
    friends: 'Друзей',
    earned: 'Заработано',
    inviteFriend: 'Пригласи друга',
    getCrystalsPerFriend: 'Получай {amount} 💎 за каждого друга',
    copyLink: 'Копировать ссылку',
    copied: 'Скопировано!',
    copyAndSend: 'Скопируй и отправь ссылку другу',
    invitedFriends: 'Приглашенные друзья',
    joined: 'Присоединился',
    noFriendsYet: 'Пока никто не присоединился по вашей ссылке',
    settings: 'Настройки',
    myPreferences: 'Мои предпочтения',
    notifications: 'Уведомления',
    support: 'Поддержка',
    aboutApp: 'О приложении',
    language: 'Язык',
  },

  // Onboarding
  onboarding: {
    welcome: 'Здравствуй',
    welcomeTitle: 'Здравствуй.\nЯ SanaSivana, путь к внутренней гармонии',
    welcomeSubtitle: 'Если тебе непросто — ты в правильном месте. Здесь можно найти спокойствие через медитации, разобраться в мыслях и обрести гармонию.',
    experienceTitle: 'Твой опыт медитации',
    experienceSubtitle: 'Расскажи о своем опыте, чтобы мы могли подобрать подходящие практики',
    beginner: 'Новичок',
    beginnerDesc: 'Только начинаю знакомиться с медитацией',
    intermediate: 'Есть опыт',
    intermediateDesc: 'Практиковал(а) несколько раз',
    advanced: 'Регулярно практикую',
    advancedDesc: 'Медитирую постоянно',
    goalsTitle: 'Твои цели',
    goalsSubtitle: 'Чего ты хочешь достичь с помощью медитации? Можно выбрать несколько вариантов.',
    reduceStress: 'Снизить стресс',
    improveSleep: 'Улучшить сон',
    increaseFocus: 'Повысить концентрацию',
    manageEmotions: 'Управлять эмоциями',
    findPeace: 'Найти внутренний покой',
    preferencesTitle: 'Твои предпочтения',
    preferencesSubtitle: 'Какие типы медитации тебе интересны и сколько времени ты готов(а) уделять практике?',
    meditationTypes: 'Типы медитации',
    mindfulness: 'Осознанность',
    breathingPractices: 'Дыхательные практики',
    visualization: 'Визуализация',
    mantras: 'Мантры',
    bodyScan: 'Сканирование тела',
    sessionDuration: 'Длительность сессии',
    congratulations: 'Поздравляем!',
    rewardReceived: 'Вы получили награду за завершение онбординга',
    continueEarning: 'Продолжайте выполнять задачи и зарабатывайте больше 💎 для разблокировки медитаций',
    startJourney: 'Начать путешествие',
  },

  // Balance page
  balancePage: {
    title: 'Баланс',
    yourBalance: 'Ваш баланс:',
    transactionHistory: 'История транзакций',
    income: 'Доход',
    expense: 'Расход',
    noTransactions: 'Нет транзакций для отображения',
  },

  // Tasks page
  tasksPage: {
    title: 'Задания',
    subtitle: 'Выполняй задания и зарабатывай кристаллы автоматически',
    achievements: 'Достижения',
    newbie: 'Новичок',
    week: 'Неделя',
    month: 'Месяц',
    expert: 'Эксперт',
    completed: 'Выполнено',
    earned: 'Заработано',
    allTasks: 'Все задания',
    loadingTasks: 'Загрузка заданий...',
  },

  // Friends page
  friendsPage: {
    title: 'Друзья',
    searchPlaceholder: 'Поиск по имени или username...',
    searchResults: 'Результаты поиска',
    searching: 'Поиск...',
    noResults: 'Никого не найдено',
    friendRequests: 'Заявки в друзья',
    myFriends: 'Мои друзья',
    noFriendsYet: 'У вас пока нет друзей',
    findFriends: 'Найдите друзей через поиск выше',
    alreadyFriends: 'Друзья',
    requestSent: 'Запрос отправлен',
    wantsToAdd: 'Хочет добавить вас',
    add: 'Добавить',
    sending: 'Отправка...',
    noPractices: 'Нет практик',
    lastPractice: 'Последняя практика:',
    medit: 'медит.',
    tasksShort: 'заданий',
    user: 'Пользователь',
  },

  // Meditation
  meditation: {
    catalog: 'Каталог медитаций',
    catalogSubtitle: 'Видео медитации для улучшения внутреннего состояния',
    loadingMeditations: 'Загрузка медитаций...',
    category: 'Категория',
    difficulty: 'Сложность',
    allLevels: 'Все уровни',
    breathing: 'Дыхание',
    meditationType: 'Медитация',
    relaxation: 'Релаксация',
    anxiety: 'Тревожность',
    sleep: 'Сон',
    beginner: 'Начинающий',
    intermediate: 'Средний',
    advanced: 'Продвинутый',
    noMeditations: 'Медитации не найдены',
    tryFilters: 'Попробуйте изменить фильтры',
    startMeditation: 'Начать медитацию',
    startFor: 'Начать медитацию за',
    yourBalance: 'У вас на балансе:',
    paid: 'Оплачено',
    free: 'Бесплатно',
    inProgress: 'В процессе',
    completed: 'Завершено',
    requiresCrystals: 'Для просмотра требуется 💎 {cost}',
    description: 'Описание',
    instructions: 'Инструкции',
    author: 'Автор',
    meditationCompleted: 'Медитация завершена!',
    greatJob: 'Отличная работа! Продолжайте практиковать регулярно.',
    notFound: 'Медитация не найдена',
    backToCatalog: 'Вернуться к каталогу',
    loadingMeditation: 'Загрузка медитации...',
    costAlert: 'Эта медитация стоит 💎 {cost}. Нажмите кнопку "Начать медитацию" для оплаты и просмотра.',
    audioMeditation: 'Аудио медитация',
  },

  // Journal
  journal: {
    title: 'Дневник состояний',
    subtitle: 'Отслеживайте своё эмоциональное состояние',
    addEntry: 'Добавить запись',
    noEntries: 'Пока нет записей',
    startJournal: 'Начните вести дневник, чтобы лучше понимать свои эмоции',
    loadingEntries: 'Загрузка записей...',
    newEntry: 'Новая запись',
    howDoYouFeel: 'Как вы себя чувствуете?',
    great: 'Отлично',
    good: 'Хорошо',
    okay: 'Нормально',
    bad: 'Плохо',
    terrible: 'Ужасно',
    note: 'Заметка',
    notePlaceholder: 'Опишите, что произошло сегодня, как вы себя чувствуете...',
    activitiesOptional: 'Активности (необязательно)',
    meditationActivity: 'Медитация',
    work: 'Работа',
    reading: 'Чтение',
    yoga: 'Йога',
    social: 'Общение',
    walk: 'Прогулка',
    selectMood: 'Пожалуйста, выберите настроение',
    addNote: 'Пожалуйста, добавьте заметку',
    savedSuccessfully: 'Запись успешно сохранена!',
    saveFailed: 'Не удалось сохранить запись. Попробуйте снова.',
    unsavedWarning: 'Вы уверены? Несохранённые данные будут потеряны.',
  },

  // Preferences
  preferences: {
    title: 'Мои предпочтения',
    meditationExperience: 'Опыт медитации',
    experienceDescription: 'Расскажите о своем опыте медитации',
    meditationGoals: 'Цели медитации',
    goalsDescription: 'Чего вы хотите достичь? (можно выбрать несколько)',
    meditationTypes: 'Типы медитации',
    typesDescription: 'Какие практики вам интересны? (можно выбрать несколько)',
    sessionDuration: 'Длительность сессии',
    durationDescription: 'Сколько времени вы готовы уделять медитации?',
    saveChanges: 'Сохранить изменения',
  },

  // Notifications
  notifications: {
    title: 'Уведомления',
    reminders: 'Напоминания',
    updates: 'Обновления',
    settingsHint: 'Настройки применяются к уведомлениям, которые мы отправляем в Telegram.',
    loadingSettings: 'Загрузка настроек...',
  },

  // Support
  supportPage: {
    title: 'Поддержка',
    newTicket: 'Новое обращение',
    subject: 'Тема обращения',
    subjectPlaceholder: 'Кратко опишите проблему',
    enterSubject: 'Введите тему обращения',
    subjectTooLong: 'Тема слишком длинная',
    problemDescription: 'Описание проблемы',
    descriptionPlaceholder: 'Подробно опишите вашу проблему или вопрос...',
    enterMessage: 'Введите текст обращения',
    messageTooLong: 'Сообщение слишком длинное',
    submitTicket: 'Отправить обращение',
    submitting: 'Отправка...',
    createError: 'Ошибка при создании обращения. Попробуйте позже.',
    openTickets: 'Открытые обращения',
    ticketOpen: 'Открыт',
    supportTeam: 'Поддержка: ',
    you: 'Вы: ',
    ticketsHistory: 'История обращений',
    allTickets: 'Все обращения, включая закрытые',
  },

  // About
  about: {
    title: 'О приложении',
    version: 'Версия',
    aboutSanaSivana: 'О SanaSivana',
    aboutDescription: 'SanaSivana - это ваш личный помощник в поддержании ментального здоровья. Мы предлагаем практики медитации, упражнения для снижения стресса, ведение дневника эмоций и многое другое.',
    ourMission: 'Наша миссия',
    missionDescription: 'Сделать поддержку ментального здоровья доступной и простой для каждого. Мы верим, что забота о психологическом благополучии должна быть частью ежедневной рутины каждого человека.',
    information: 'Информация',
    developer: 'Разработчик',
    releaseDate: 'Дата выпуска',
    category: 'Категория',
    healthFitness: 'Здоровье и фитнес',
    legalInfo: 'Правовая информация',
    termsOfService: 'Пользовательское соглашение',
    privacyPolicy: 'Политика конфиденциальности',
    licenseAgreement: 'Лицензионное соглашение',
    copyright: '© 2025 SanaSivana. Все права защищены.',
  },

  // Language
  languagePage: {
    title: 'Язык',
    selectLanguage: 'Выберите язык',
    english: 'English',
    russian: 'Русский',
    spanish: 'Español',
  },

  // Calendar
  calendar: {
    months: [
      'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
      'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
    ],
    weekdays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
    previousMonth: 'Предыдущий месяц',
    nextMonth: 'Следующий месяц',
    practiceDay: 'День практики',
  },

  // Insufficient balance modal
  insufficientBalance: {
    title: 'Недостаточно кристаллов',
    required: 'Требуется:',
    youHave: 'У вас:',
    missing: 'Не хватает:',
    howToEarn: 'Как заработать кристаллы?',
    completeTasks: 'Выполняйте задания',
    taskReward: 'Получайте до 30 кристаллов за задание',
    inviteFriends: 'Приглашайте друзей',
    friendReward: '15 кристаллов за каждого друга',
    practiceMeditations: 'Практикуйте медитации',
    practiceReward: 'Регулярная практика приносит награды',
    topUpBalance: '💎 Пополнить баланс',
    goToTasks: 'Перейти к заданиям',
    inviteFriendsBtn: 'Пригласить друзей',
  },

  // App loading
  appLoading: {
    loading: 'Загрузка SanaSivana...',
    connectingTelegram: 'Подключение к Telegram...',
    verifyingAuth: 'Проверка авторизации...',
    checkingProgress: 'Проверка вашего прогресса...',
  },
};

